import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { toast } from 'react-hot-toast';
import { adminService } from '../../services/admin.service';
import AdminNavbar from '../../components/admin/AdminNavbar';

const DomainForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    hostname: '',
    displayName: '',
    appName: '',
    shortName: 'Rasca y Gana',
    isActive: true,
    cookieScriptUrl: '',
    cookieScriptLwid: '',
    cookieScriptDataId: '',
    termsUrl: '',
    privacyUrl: ''
  });

  useEffect(() => {
    if (id) {
      const loadDomain = async () => {
        try {
          const domain = await adminService.getDomain(id);
          setFormData({
            hostname: domain.hostname || '',
            displayName: domain.displayName || '',
            appName: domain.appName || '',
            shortName: domain.shortName || 'Rasca y Gana',
            isActive: domain.isActive !== false,
            cookieScriptUrl: domain.cookieScriptUrl || '',
            cookieScriptLwid: domain.cookieScriptLwid || '',
            cookieScriptDataId: domain.cookieScriptDataId || '',
            termsUrl: domain.termsUrl || '',
            privacyUrl: domain.privacyUrl || ''
          });
        } catch (error) {
          toast.error('Error al cargar el dominio');
          navigate('/pmpl/admin/domains');
        }
      };
      loadDomain();
    }
  }, [id, navigate]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (id) {
        await adminService.updateDomain(id, formData);
        toast.success('Dominio actualizado correctamente');
      } else {
        await adminService.createDomain(formData);
        toast.success('Dominio creado correctamente');
      }
      navigate('/pmpl/admin/domains');
    } catch (error) {
      toast.error(error.response?.data?.message || 'Error al guardar el dominio');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <AdminNavbar />
      <Container>
        <Header>
          <BackButton onClick={() => navigate('/pmpl/admin/domains')}>
            ← Volver
          </BackButton>
          <Title>{id ? 'Editar Dominio' : 'Nuevo Dominio'}</Title>
        </Header>

        <Form onSubmit={handleSubmit}>
          <Section>
            <SectionTitle>Configuración del dominio</SectionTitle>
            <FormGroup>
              <Label>Hostname *</Label>
              <Input
                type="text"
                name="hostname"
                value={formData.hostname}
                onChange={handleChange}
                placeholder="ej: pamplonews.com, rascaygana.onrender.com"
                required
                disabled={!!id}
              />
              {id && <HelpText>El hostname no se puede modificar una vez creado</HelpText>}
            </FormGroup>

            <FormGroup>
              <Label>Nombre para mostrar *</Label>
              <Input
                type="text"
                name="displayName"
                value={formData.displayName}
                onChange={handleChange}
                placeholder="ej: Pamplonews"
                required
              />
            </FormGroup>

            <FormGroup>
              <Label>Nombre completo de la app</Label>
              <Input
                type="text"
                name="appName"
                value={formData.appName}
                onChange={handleChange}
                placeholder="ej: Rasca y Gana de Pamplonews (vacío = Rasca y Gana de {displayName})"
              />
            </FormGroup>

            <FormGroup>
              <Label>Nombre corto</Label>
              <Input
                type="text"
                name="shortName"
                value={formData.shortName}
                onChange={handleChange}
                placeholder="ej: Rasca y Gana"
              />
            </FormGroup>

            <CheckboxLabel>
              <input
                type="checkbox"
                name="isActive"
                checked={formData.isActive}
                onChange={handleChange}
              />
              Dominio activo
            </CheckboxLabel>
          </Section>

          <Section>
            <SectionTitle>Script de cookies</SectionTitle>
            <FormGroup>
              <Label>URL del script</Label>
              <Input
                type="url"
                name="cookieScriptUrl"
                value={formData.cookieScriptUrl}
                onChange={handleChange}
                placeholder="https://cdn.lawwwing.com/... o https://legal-pmoz.onrender.com/snippet/loader.min.js"
              />
            </FormGroup>
            <FormGroup>
              <Label>ID Lawwwing (data-lwid)</Label>
              <Input
                type="text"
                name="cookieScriptLwid"
                value={formData.cookieScriptLwid}
                onChange={handleChange}
                placeholder="463cf9ff-99ba-429f-8c25-450ebf07ff69"
              />
            </FormGroup>
            <FormGroup>
              <Label>ID legal-pmoz (data-id)</Label>
              <Input
                type="text"
                name="cookieScriptDataId"
                value={formData.cookieScriptDataId}
                onChange={handleChange}
                placeholder="78ab288b463542d8abff394f"
              />
            </FormGroup>
            <HelpText>Usa uno u otro según el proveedor. Lawwwing: data-lwid. legal-pmoz: data-id.</HelpText>
          </Section>

          <Section>
            <SectionTitle>Documentos legales</SectionTitle>
            <FormGroup>
              <Label>URL Términos y condiciones</Label>
              <Input
                type="url"
                name="termsUrl"
                value={formData.termsUrl}
                onChange={handleChange}
                placeholder="https://..."
              />
            </FormGroup>
            <FormGroup>
              <Label>URL Política de privacidad</Label>
              <Input
                type="url"
                name="privacyUrl"
                value={formData.privacyUrl}
                onChange={handleChange}
                placeholder="https://..."
              />
            </FormGroup>
          </Section>

          <ButtonGroup>
            <CancelButton type="button" onClick={() => navigate('/pmpl/admin/domains')}>
              Cancelar
            </CancelButton>
            <SaveButton type="submit" disabled={loading}>
              {loading ? 'Guardando...' : (id ? 'Actualizar' : 'Crear')}
            </SaveButton>
          </ButtonGroup>
        </Form>
      </Container>
    </>
  );
};

const Container = styled.div`
  padding: 2rem;
  max-width: 800px;
  margin: 0 auto;
`;

const Header = styled.div`
  margin-bottom: 2rem;
`;

const BackButton = styled.button`
  background: transparent;
  color: #999;
  border: none;
  cursor: pointer;
  margin-bottom: 1rem;
  font-size: 0.95rem;

  &:hover {
    color: #ffd700;
  }
`;

const Title = styled.h1`
  color: #ffd700;
  margin: 0;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const Section = styled.section`
  background: #2a2a2a;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const SectionTitle = styled.h2`
  color: #ffd700;
  font-size: 1.25rem;
  margin: 0 0 1.5rem 0;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
`;

const Label = styled.label`
  color: #999;
  font-size: 0.9rem;
`;

const Input = styled.input`
  background: #333;
  border: 1px solid #444;
  border-radius: 4px;
  padding: 0.75rem;
  color: white;
  font-size: 1rem;

  &:focus {
    outline: none;
    border-color: #ffd700;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const HelpText = styled.span`
  color: #666;
  font-size: 0.8rem;
`;

const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #fff;
  cursor: pointer;

  input {
    width: 1.2rem;
    height: 1.2rem;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
`;

const SaveButton = styled.button`
  padding: 0.75rem 1.5rem;
  background: #ffd700;
  color: #1a1a1a;
  border: none;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: #ffed4a;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

const CancelButton = styled.button`
  padding: 0.75rem 1.5rem;
  background: transparent;
  color: #999;
  border: 1px solid #444;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

export default DomainForm;
